import { ModuleRegistry } from "seneca-common/features/module/registry";

type Args = {
  moduleRegistry: ModuleRegistry;
  moduleType: string;
  moduleContent: any;
};

export default function moduleCanBeTested({
  moduleRegistry,
  moduleType,
  moduleContent: moduleContentParam
}: Args) {
  const moduleObject = moduleRegistry.modules.getModule(moduleType);
  const readOnly = moduleObject.isReadOnly();
  const canBeTested = moduleObject.getCanBeTested();

  const moduleContent = moduleContentParam.toJS
    ? moduleContentParam.toJS()
    : moduleContentParam;

  const moduleTypeIsTestableButContentHasNoTestableElements =
    canBeTested && !canBeTested(moduleContent);

  if (readOnly || moduleTypeIsTestableButContentHasNoTestableElements) {
    return false;
  }

  // If no 'canBeTested' function is provided by the moduleType, we assume all moduleContent for that module can be tested
  return true;
}
